import { t } from 'i18next';
import { Text } from '@mantine/core';
import { Column, ReportsTableItem } from 'utils/models';
import { getReportIndicator } from 'utils/helpers';
import { formatDate } from 'utils/dates';
import { IndicatorLabel } from 'components/IndicatorLabel';
import { DownloadReportActionIcon } from '../DownloadReportActionIcon';

export const ReportsOverviewColumns = () => {
  const columns: Column<ReportsTableItem>[] = [
    {
      header: t('reports_trigger'),
      width: 25,
      renderItem: (item) => <Text>{`${t(`reason_${item.trigger.toLowerCase()}`)}`}</Text>,
    },
    {
      header: t('reports_timestamp'),
      width: 25,
      renderItem: (item) => formatDate({ timestamp: item.creationTimestamp, formatWithTime: true }),
    },
    {
      header: t('reports_indicator'),
      width: 35,
      renderItem: (item) => <IndicatorLabel indicator={getReportIndicator(item.tags)} />,
    },
    {
      header: t('table_actions'),
      width: 15,
      renderItem: (item) => <DownloadReportActionIcon reportId={item.id} />,
    },
  ];

  return columns;
};
